import Default from './default';
import Milestones from '../components/milestones';
class Project extends Default {
	namespace = 'project';

	beforeEnter = data => {
		super.beforeEnter(data);
		const $scope = $(data.next.container);
		this.initMilestones($scope);
	};

	beforeLeave = data => {
		super.beforeLeave(data);
	};

	afterLeave = data => {
		super.afterLeave(data);
	};

	afterEnter = data => {
		super.afterEnter(data);
	};

	initMilestones = $scope => {
		const $milestones = $scope.find('[data-milestones="el"]');
		// loop through milestones and initialize them
		$milestones.each((i, el) => {
			new Milestones($(el));
		});
	};
}

export default new Project();
